module.exports = __webpack_public_path__ + "img/home_a2.4ef6e2fb.png";